self._ENTRIES ||= {};
const modProm = import('MODULE');
modProm.catch(() => {});
self._ENTRIES["middleware_middleware"] = new Proxy(modProm, {
    get(modProm, name) {
        if (name === "then") {
            return (res, rej) => modProm.then(res, rej);
        }
        let result = (...args) => modProm.then((mod) => (0, mod[name])(...args));
        result.then = (res, rej) => modProm.then((mod) => mod[name]).then(res, rej);
        return result;
    },
});
